import { render, staticRenderFns } from "./pageView.vue?vue&type=template&id=5654373a&scoped=true"
import script from "./pageView.vue?vue&type=script&lang=js"
export * from "./pageView.vue?vue&type=script&lang=js"
import style0 from "./pageView.vue?vue&type=style&index=0&id=5654373a&prod&scoped=true&lang=css"
import style1 from "./pageView.vue?vue&type=style&index=1&id=5654373a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5654373a",
  null
  
)

export default component.exports